export default __webpack_public_path__ + "static/allency-banner-briefcase-eb3f1aaa75fff67d38f0e2e1df4b2c09.png";